<template>
    <div class="flex items-center border rounded-lg px-4 py-8 h-16 bg-transparent border-snow-200">
        <div class="flex items-center justify-center">
            <div class="img_skeleton"></div>
            <div class="name_skeleton"></div>
        </div>
    </div>
</template>

<script>
export default {
  // name: 'telco-skeleton-loader'
}
</script>

<style scoped>
.img_skeleton {
    height: 30px;
    width: 30px;
    border-radius: 50%;
    margin-right: 10px;
    animation: pulse-bg 1s ease-in-out infinite normal both;
}

.name_skeleton {
    width: 50px;
    height: 15px;
    border-radius: 10px;
    animation: pulse-bg 1s ease-in-out infinite normal both;
}


</style>
